<bb-avatar-ui name="Jane Doe" size="lg"></bb-avatar-ui>
